module.exports = __webpack_public_path__ + "img/pertro_canada.1d38513b.jpg";